import { useState } from 'react';
import { unique } from 'radash';
import { FaCaretDown, FaCaretUp } from 'react-icons/fa';
import { Check } from './Check';
import { Button } from './Button';
import { Label } from './Label';
import { Help } from './Help';
import { colors } from '../../constants';

export const SelectShared = ({ display, selector, label, help }) => {
  const [open, setOpen] = useState();

  const style = {
    border: '1px solid #ccc',
    padding: 10,
    borderRadius: 5,
  };

  const bgNode = (
    <div
      onClick={() => setOpen(false)}
      style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: 200 }}
    ></div>
  );

  return (
    <div style={{ position: 'relative' }}>
      <Label label={label} />
      <Help help={help} />
      <div
        style={{
          ...style,
          display: 'inline-flex',
          alignItems: 'center',
          padding: '8px 10px',
          gap: 10,
          cursor: 'pointer',
          userSelect: 'none',
        }}
        onClick={() => setOpen(!open)}
      >
        <div style={{ display: 'inline-flex', gap: 5, whiteSpace: 'nowrap', minWidth: 120, fontSize: 14 }}>
          {display}
          <span>&nbsp;</span>
        </div>
        <div style={{ display: 'inline-flex', alignItems: 'center', borderLeft: '1px solid #ccc', paddingLeft: 8 }}>
          <FaCaretDown />
        </div>
      </div>

      {open && (
        <div
          style={{
            position: 'absolute',
            marginTop: 1,
            zIndex: 300,
            widthx: '100%',
            minWidth: 200,
            border: '1px solid #ccc',
            background: 'white',
            padding: 10,
            borderRadius: 5,
            fontSize: 14,
            boxShadow: '0 3px 5px rgba(0,0,0,0.15), 0 10px 20px rgba(0,0,0,0.10)',
          }}
        >
          {selector({ onClose: () => setOpen(false) })}
        </div>
      )}
      {open && bgNode}
    </div>
  );
};
